import { isHalloween } from "@/lib/halloween";

const RE = /(halloween)/gi;

export function spooky(text, k = "hw") {
  if (typeof text !== "string" || !isHalloween() || !/halloween/i.test(text)) return text;
  return text.split(RE).map((part, i) => (i % 2 ? <span key={`${k}-${i}`} className="hw-word" data-testid="hw-word">🎃{part}</span> : part));
}
